// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"12":"flow-game","18":"Edit","420":"Shop","443":"about","757":"game","842":"map","879":"Score"}[chunkId] || chunkId) + "." + {"12":"ea317c2b","18":"fe0ea28c","420":"9eadfcf8","443":"b0fec25b","757":"22b96927","773":"179ecda7","842":"d3713d37","879":"ae9c8bda"}[chunkId] + ".js";
};